const DEFAULT_METRIC_LOGGER = (metric) => {
  if (import.meta.env.DEV) {
    console.info("[Performance]", metric.name, metric.value, metric);
  }
};

const now = () =>
  typeof performance !== "undefined" && performance.now
    ? performance.now()
    : Date.now();

export const createPerfTimer = (label) => {
  const start = now();

  return {
    end(extra = {}) {
      const duration = now() - start;
      return {
        label,
        duration,
        ...extra,
      };
    },
  };
};

export const reportWebVitals = async (onMetric = DEFAULT_METRIC_LOGGER) => {
  if (typeof window === "undefined") return;

  const { onCLS, onFCP, onINP, onLCP, onTTFB } = await import("web-vitals");
  onCLS(onMetric);
  onFCP(onMetric);
  onINP(onMetric);
  onLCP(onMetric);
  onTTFB(onMetric);
};

export const observeLongTasks = (onLongTask = DEFAULT_METRIC_LOGGER) => {
  if (
    typeof window === "undefined" ||
    typeof PerformanceObserver === "undefined"
  ) {
    return () => {};
  }

  let observer;
  try {
    observer = new PerformanceObserver((entryList) => {
      entryList.getEntries().forEach((entry) => {
        onLongTask({
          name: "longtask",
          value: entry.duration,
          startTime: entry.startTime,
        });
      });
    });
    observer.observe({ entryTypes: ["longtask"] });
  } catch {
    return () => {};
  }

  return () => observer?.disconnect();
};

export const initPerformanceMonitoring = (options = {}) => {
  const { onMetric = DEFAULT_METRIC_LOGGER } = options;
  const teardownLongTasks = observeLongTasks(onMetric);

  reportWebVitals(onMetric).catch((error) => {
    if (import.meta.env.DEV) {
      console.warn("[Performance] Failed to load web-vitals:", error);
    }
  });

  return () => {
    teardownLongTasks();
  };
};
